/**
 * @generated SignedSource<<9c80417b98093e0f1f2b91d57b094821>>
 * @relayHash 05e7b1c48eb093487e6f61c2d33ec114
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 50fb6611f05ec7b8c2b4fb2280ae50f16283f575729508ae5b8ce76904862a92

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectPanelQuery$variables = {
  ari: string;
  isProjectNativeIntegrationEnabled: boolean;
};
export type ProjectPanelQuery$data = {
  readonly me: {
    readonly user: {
      readonly accountId: string;
      readonly id: string;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
  };
  readonly projects_byId: {
    readonly canEditMembers: boolean | null | undefined;
    readonly contributors: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly userContributor: {
            readonly id: string;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly id: string;
    readonly owner: {
      readonly id: string;
    } | null | undefined;
    readonly url: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectActionsContent" | "ProjectContributesTo" | "ProjectContributors" | "ProjectCustomFields" | "ProjectFocusAreas" | "ProjectFollowers" | "ProjectJiraWork" | "ProjectLinks" | "ProjectOwner" | "ProjectPanelHeader" | "ProjectPanelTabs" | "ProjectStartDate" | "ProjectStatusField" | "ProjectTags" | "ProjectTargetDate" | "ProjectWorkTracked" | "RelatedProjects">;
  };
};
export type ProjectPanelQuery = {
  response: ProjectPanelQuery$data;
  variables: ProjectPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ari"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isProjectNativeIntegrationEnabled"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "picture"
},
v4 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v5 = [
  {
    "kind": "Variable",
    "name": "projectId",
    "variableName": "ari"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "url"
},
v7 = [
  (v1/*: any*/)
],
v8 = {
  "kind": "ScalarField",
  "name": "canEditMembers"
},
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = [
  (v9/*: any*/),
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
],
v11 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isUser"
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "AtlassianAccountUserExtendedProfile",
      "kind": "LinkedField",
      "name": "extendedProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jobTitle"
        }
      ]
    }
  ],
  "type": "AtlassianAccountUser"
},
v13 = {
  "kind": "ScalarField",
  "name": "count"
},
v14 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v15 = {
  "kind": "ScalarField",
  "name": "dark"
},
v16 = {
  "kind": "ScalarField",
  "name": "light"
},
v17 = {
  "kind": "ScalarField",
  "name": "description"
},
v18 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v19 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v20 = {
  "kind": "ScalarField",
  "name": "key"
},
v21 = {
  "kind": "ScalarField",
  "name": "value"
},
v22 = [
  (v21/*: any*/)
],
v23 = {
  "kind": "ScalarField",
  "name": "summary"
},
v24 = [
  {
    "concreteType": "TownsquareLinkEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TownsquareLink",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v6/*: any*/),
          (v2/*: any*/)
        ]
      }
    ]
  },
  (v14/*: any*/)
],
v25 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v26 = [
  (v20/*: any*/),
  (v1/*: any*/)
],
v27 = {
  "kind": "InlineFragment",
  "selections": (v7/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v28 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v29 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v30 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                (v2/*: any*/),
                (v1/*: any*/),
                (v4/*: any*/),
                (v3/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v29/*: any*/),
            (v28/*: any*/)
          ]
        }
      ]
    },
    (v14/*: any*/)
  ]
},
v31 = [
  {
    "kind": "ScalarField",
    "name": "label"
  }
],
v32 = [
  (v9/*: any*/),
  (v3/*: any*/),
  (v2/*: any*/),
  (v1/*: any*/)
],
v33 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v32/*: any*/)
},
v34 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v32/*: any*/)
},
v35 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v36 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v23/*: any*/),
      (v17/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/),
      (v28/*: any*/),
      (v35/*: any*/)
    ],
    "type": "TownsquareHighlight",
    "abstractKey": "__isTownsquareHighlight"
  }
],
v37 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v17/*: any*/)
],
v38 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v39 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v40 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    (v18/*: any*/)
  ]
},
v41 = {
  "kind": "ScalarField",
  "name": "webUrl"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "RequiredField",
        "field": {
          "args": (v5/*: any*/),
          "concreteType": "TownsquareProject",
          "kind": "LinkedField",
          "name": "projects_byId",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v6/*: any*/),
            {
              "kind": "LinkedField",
              "name": "owner",
              "plural": false,
              "selections": (v7/*: any*/)
            },
            {
              "concreteType": "TownsquareContributorConnection",
              "kind": "LinkedField",
              "name": "contributors",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareContributorEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "concreteType": "TownsquareContributor",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "userContributor",
                          "plural": false,
                          "selections": (v7/*: any*/)
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            (v8/*: any*/),
            {
              "condition": "isProjectNativeIntegrationEnabled",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ProjectJiraWork"
                }
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectPanelHeader"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectTags"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectTargetDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectStatusField"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectOwner"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectLinks"
            },
            {
              "condition": "isProjectNativeIntegrationEnabled",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ProjectWorkTracked"
                }
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectFocusAreas"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectStartDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "RelatedProjects"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectContributesTo"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectContributors"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectFollowers"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectActionsContent"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectPanelTabs"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectCustomFields"
            }
          ]
        },
        "action": "THROW",
        "path": "projects_byId"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v5/*: any*/),
        "concreteType": "TownsquareProject",
        "kind": "LinkedField",
        "name": "projects_byId",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v6/*: any*/),
          {
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": (v10/*: any*/)
          },
          {
            "concreteType": "TownsquareContributorConnection",
            "kind": "LinkedField",
            "name": "contributors",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareContributorEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareContributor",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "userContributor",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v1/*: any*/),
                          (v4/*: any*/),
                          (v11/*: any*/),
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v12/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareTeamContributor",
                        "kind": "LinkedField",
                        "name": "teamContributor",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "contributingMembers",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v4/*: any*/),
                                      (v1/*: any*/),
                                      (v11/*: any*/),
                                      (v2/*: any*/),
                                      (v3/*: any*/),
                                      (v12/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v13/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TeamV2",
                            "kind": "LinkedField",
                            "name": "team",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "displayName"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "smallAvatarImageUrl"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "profileUrl"
                              },
                              {
                                "concreteType": "TeamMemberConnectionV2",
                                "kind": "LinkedField",
                                "name": "members",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TeamMemberEdgeV2",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TeamMemberV2",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "member",
                                            "plural": false,
                                            "selections": (v10/*: any*/)
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v14/*: any*/)
            ]
          },
          (v8/*: any*/),
          (v2/*: any*/),
          {
            "concreteType": "TownsquareWorkspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": (v7/*: any*/)
          },
          {
            "concreteType": "TownsquareIconURIs",
            "kind": "LinkedField",
            "name": "iconUrl",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareThemeURIs",
                "kind": "LinkedField",
                "name": "roundedSquare",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareTagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareTagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareTag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "usageCount"
                      },
                      (v17/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  (v19/*: any*/)
                ]
              },
              (v14/*: any*/)
            ]
          },
          (v20/*: any*/),
          {
            "kind": "ScalarField",
            "name": "isArchived"
          },
          {
            "concreteType": "TownsquareProjectState",
            "kind": "LinkedField",
            "name": "state",
            "plural": false,
            "selections": (v22/*: any*/)
          },
          {
            "concreteType": "TownsquareTargetDate",
            "kind": "LinkedField",
            "name": "dueDate",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareTargetDateRange",
                "kind": "LinkedField",
                "name": "dateRange",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "start"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "end"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "confidence"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "startDate"
          },
          {
            "concreteType": "TownsquareProjectUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              (v14/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "watcherCount"
          },
          {
            "concreteType": "TownsquareProjectUpdate",
            "kind": "LinkedField",
            "name": "latestUserUpdate",
            "plural": false,
            "selections": [
              (v23/*: any*/),
              {
                "concreteType": "TownsquareUpdateNoteConnection",
                "kind": "LinkedField",
                "name": "updateNotes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareUpdateNoteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareUpdateNote",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          (v17/*: any*/),
                          (v1/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v1/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareLinkConnection",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": (v24/*: any*/)
          },
          {
            "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseConnection",
            "kind": "LinkedField",
            "name": "focusAreas",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v25/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "userPermissions"
                          },
                          (v2/*: any*/),
                          (v6/*: any*/),
                          {
                            "concreteType": "MercuryFocusAreaStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": (v26/*: any*/)
                          },
                          {
                            "concreteType": "MercuryFocusAreaHealth",
                            "kind": "LinkedField",
                            "name": "health",
                            "plural": false,
                            "selections": (v26/*: any*/)
                          }
                        ],
                        "type": "MercuryFocusArea"
                      },
                      (v27/*: any*/)
                    ]
                  },
                  (v1/*: any*/)
                ]
              },
              (v14/*: any*/)
            ]
          },
          (v28/*: any*/),
          {
            "concreteType": "TownsquareProjectDependencyConnection",
            "kind": "LinkedField",
            "name": "dependencies",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectDependencyEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareProjectDependency",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "linkType"
                      },
                      {
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "incomingProject",
                        "plural": false,
                        "selections": (v7/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "outgoingProject",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v20/*: any*/),
                          (v2/*: any*/),
                          (v6/*: any*/),
                          {
                            "concreteType": "TownsquareIconURIs",
                            "kind": "LinkedField",
                            "name": "iconUrl",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareThemeURIs",
                                "kind": "LinkedField",
                                "name": "square",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/),
                                  (v15/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v14/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "goals",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v6/*: any*/),
                      (v2/*: any*/),
                      {
                        "concreteType": "TownsquareStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": (v22/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareGoalType",
                        "kind": "LinkedField",
                        "name": "goalType",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalTypeIcon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/)
                            ]
                          },
                          (v1/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v14/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareUserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "concreteType": "TownsquareUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v1/*: any*/),
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareProjectDescription",
            "kind": "LinkedField",
            "name": "description",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "what"
              },
              {
                "kind": "ScalarField",
                "name": "why"
              },
              {
                "kind": "ScalarField",
                "name": "measurement"
              }
            ]
          },
          (v30/*: any*/),
          {
            "concreteType": "TownsquareProjectUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareProjectUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "ari"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "missedUpdate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "updateType"
                      },
                      (v23/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v1/*: any*/),
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": (v31/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareProjectState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": (v22/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v4/*: any*/),
                          (v2/*: any*/),
                          (v1/*: any*/)
                        ]
                      },
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v6/*: any*/),
                      {
                        "concreteType": "TownsquareProjectState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v22/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v31/*: any*/)
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDateConfidence"
                      },
                      {
                        "concreteType": "TownsquareUpdateNoteConnection",
                        "kind": "LinkedField",
                        "name": "updateNotes",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareUpdateNoteEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareUpdateNote",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  (v23/*: any*/),
                                  (v17/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "archived"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "TownsquareHighlightConnection",
                        "kind": "LinkedField",
                        "name": "highlights",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareHighlightEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v23/*: any*/),
                                  (v17/*: any*/),
                                  (v9/*: any*/),
                                  (v1/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isTownsquareHighlight"
                                  },
                                  (v33/*: any*/),
                                  (v34/*: any*/),
                                  (v28/*: any*/),
                                  (v35/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v30/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareHighlightEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v1/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v36/*: any*/),
                        "type": "TownsquareLearning"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v36/*: any*/),
                        "type": "TownsquareRisk"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v36/*: any*/),
                        "type": "TownsquareDecision"
                      }
                    ]
                  }
                ]
              },
              (v14/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareCustomFieldConnection",
            "kind": "LinkedField",
            "name": "customFields",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareCustomFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v25/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v37/*: any*/),
                                "type": "TownsquareTextCustomFieldDefinition"
                              },
                              (v27/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              {
                                "alias": "textValue",
                                "kind": "ScalarField",
                                "name": "value"
                              },
                              (v1/*: any*/)
                            ]
                          }
                        ],
                        "type": "TownsquareTextCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v25/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v37/*: any*/),
                                "type": "TownsquareNumberCustomFieldDefinition"
                              },
                              (v27/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "alias": "numberValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          }
                        ],
                        "type": "TownsquareNumberCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v25/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v37/*: any*/),
                                "type": "TownsquareUserCustomFieldDefinition"
                              },
                              (v27/*: any*/)
                            ]
                          },
                          {
                            "args": (v38/*: any*/),
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v1/*: any*/),
                                      (v11/*: any*/),
                                      (v2/*: any*/),
                                      (v3/*: any*/)
                                    ]
                                  },
                                  (v39/*: any*/)
                                ]
                              },
                              (v40/*: any*/),
                              (v14/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v38/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldUser_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          }
                        ],
                        "type": "TownsquareUserCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v25/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v1/*: any*/),
                                  (v2/*: any*/),
                                  (v17/*: any*/),
                                  {
                                    "args": (v38/*: any*/),
                                    "concreteType": "TownsquareCustomFieldTextAllowedValueConnection",
                                    "kind": "LinkedField",
                                    "name": "allowedValues",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareCustomFieldTextAllowedValueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareCustomFieldTextAllowedValueNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v1/*: any*/),
                                              (v21/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "allowedValues(first:100)"
                                  }
                                ],
                                "type": "TownsquareTextSelectCustomFieldDefinition"
                              },
                              (v27/*: any*/)
                            ]
                          },
                          {
                            "args": (v38/*: any*/),
                            "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v1/*: any*/),
                                      {
                                        "alias": "selectValue",
                                        "kind": "ScalarField",
                                        "name": "value"
                                      },
                                      (v9/*: any*/)
                                    ]
                                  },
                                  (v39/*: any*/)
                                ]
                              },
                              (v40/*: any*/),
                              (v14/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v38/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldTextSelect_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          }
                        ],
                        "type": "TownsquareTextSelectCustomField"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "isProjectNativeIntegrationEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 5
                  }
                ],
                "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemConnection",
                "kind": "LinkedField",
                "name": "linkedJiraWorkItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v1/*: any*/),
                              (v41/*: any*/),
                              (v23/*: any*/),
                              {
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "permission",
                                    "value": "EDIT_ISSUES"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "hasProjectPermission",
                                "storageKey": "hasProjectPermission(permission:\"EDIT_ISSUES\")"
                              },
                              {
                                "concreteType": "JiraStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "statusId"
                                  },
                                  (v2/*: any*/),
                                  {
                                    "concreteType": "JiraStatusCategory",
                                    "kind": "LinkedField",
                                    "name": "statusCategory",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "statusCategoryId"
                                      },
                                      (v2/*: any*/),
                                      (v1/*: any*/)
                                    ]
                                  },
                                  (v1/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "issueTypeId"
                                  },
                                  (v2/*: any*/),
                                  (v1/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraIssue"
                          },
                          (v27/*: any*/)
                        ]
                      },
                      (v1/*: any*/)
                    ]
                  }
                ],
                "storageKey": "linkedJiraWorkItems(first:5)"
              }
            ]
          },
          {
            "condition": "isProjectNativeIntegrationEnabled",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": "workTrackingLinks",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  },
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "WORK_TRACKING"
                  }
                ],
                "concreteType": "TownsquareLinkConnection",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": (v24/*: any*/),
                "storageKey": "links(first:1,type:\"WORK_TRACKING\")"
              },
              {
                "concreteType": "TownsquareFusionDetails",
                "kind": "LinkedField",
                "name": "fusion",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "synced"
                  },
                  {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "issue",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v20/*: any*/),
                      (v41/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "50fb6611f05ec7b8c2b4fb2280ae50f16283f575729508ae5b8ce76904862a92",
    "metadata": {},
    "name": "ProjectPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e65b0c1cff179f718b3db2224d665ed5";

export default node;
